import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Input, Label } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
// Local deps
import './RFFInputField.scss';

function RFFInputField({
  input,
  meta,
  labelCol,
  inputCol,
  errorCol,
  label,
  isRequired,
  tooltip,
  className,
  ...otherProps
}) {

  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol} style={{ display: 'flex' }}>
            <Label
              className={`nf-rff-input-field__label ${className}`}
              htmlFor={input.name}
            >
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
            {tooltip && (
              <React.Fragment>
                <a href
                  className="nf-rff-tooltip"
                  data-tip={tooltip}
                  data-for={`tooltip-${label}`}
                >
                  <span> &#9432;</span>
                </a>
                <ReactTooltip
                  id={`tooltip-${label}`}
                  place="right"
                  type="dark"
                  effect="float"
                />
              </React.Fragment>
            )}
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <Input
            className="nf-rff-input-field__input"
            {...input}
            {...otherProps}
          />{' '}
          {meta.touched && meta.error && (
            <div className="nf-rff-input-field__error" style={{ marginTop: 4 }}>{meta.error}</div>
          )}
        </Col>
      </Row>
    </div>
  );
}


RFFInputField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6 },
  errorCol: { md: 3 },
  isRequired: false,
  className: '',
  tooltip: '',
};

RFFInputField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  tooltip: PropTypes.string,
};

export default RFFInputField;



// WEBPACK FOOTER //
// ./src/components/form/RFFInputField/RFFInputField.jsx